import ListEntitiesItemDescriptionMultipleLines, {
  type ListEntitiesItemDescriptionMultipleLinesProps,
} from "components/ListEntitiesItem/Description/MultipleLines";
import { Maybe } from "types/generated";

import TableCellEmpty from "./CellEmpty";

type TableCellDescriptionProps = {
  description?: Maybe<string>;
  actionText?: string;
  drawerTitle?: string;
} & Pick<ListEntitiesItemDescriptionMultipleLinesProps, "onShowFullDescription">;

/**
 * TODO: adopt showing description in the table cell with new actions flow
 */
const TableCellDescription = ({
  description,
  actionText,
  drawerTitle,
  onShowFullDescription,
}: TableCellDescriptionProps) => {
  if (!description) {
    return <TableCellEmpty />;
  }

  return (
    <ListEntitiesItemDescriptionMultipleLines
      lines={1}
      description={description}
      onShowFullDescription={onShowFullDescription}
      actionText={actionText}
      drawerTitle={drawerTitle}
      hasChevronLink
    />
  );
};

TableCellDescription.displayName = "DS.Table.CellDescription";

export default TableCellDescription;
